const Types = {
  SCENE: 'scene',
  WIDGET: 'widget',
};

export default Types;



// WEBPACK FOOTER //
// ./src/dnd/types.js